export default {
      id: "command__refresh-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.svg#command__refresh",
      toString: function () {
        return this.url;
      }
    }